/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M6 13.5c0-.8284-.6716-1.5-1.5-1.5h-3c-.8284 0-1.5.6716-1.5 1.5V24h6V13.5Zm-1.5 0v9h-3v-9h3Zm6-13.5C9.6716 0 9 .6716 9 1.5V24h6V1.5c0-.8284-.6716-1.5-1.5-1.5h-3Zm3 22.5v-21h-3v21h3Zm6-18c-.8284 0-1.5.6716-1.5 1.5v18h6V6c0-.8284-.6716-1.5-1.5-1.5h-3Zm3 1.5h-3v16.5h3V6Z"
    clipRule="evenodd"
  />,
  'LineChart'
);
